<template>
  <base-modal ref="modal">
    <base-card shadow>
      <h3 class="tw-text-xl tw-font-thin">Pause Plan</h3>
      <div class="tw-mt-5">
        <div class="tw-text-gray-800 tw-font-normal">Are you sure you want to pause this plan?</div>
        <div class="tw-text-gray-500 tw-text-sm">
          <span>Pausing this plan will stop all member payments immediately and move the plan into 'Paused' status.</span
          ><span v-if="useCreditsSetting === true" class="tw-ml-1"
            >When a plan is paused the member's credits are retained but can not be redeemed until they resume their plan.</span
          >
        </div>
      </div>
      <div class="sm:tw-flex sm:tw-flex-row-reverse tw-mt-4">
        <base-button @click="pausePlan" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3">Pause Plan</base-button>
        <base-button @click="hide" type="flat" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">
          Cancel
        </base-button>
      </div>
      <inline-error id="pause-business-member-plan-modal-error" :title="errorTitle" :message="errorMessage" :error="error" />
    </base-card>
  </base-modal>
</template>
<script>
import InlineError from "@/components/InlineError";

export default {
  name: "BusinessMemberPlanPause",
  components: { InlineError },
  props: {
    businessId: String,
    userId: String,
    userBusinessPlanId: String,
    useCreditsSetting: Boolean,
  },
  data() {
    return {
      isLoading: false,
      errorTitle: "",
      errorMessage: "",
      error: null,
    };
  },
  computed: {},
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    pausePlan() {
      this.isLoading = true;

      this.$axios
        .put(`/businesses/${this.businessId}/members/${this.userId}/memberplans/${this.userBusinessPlanId}/pause`)
        .then(() => {
          this.isLoading = false;
          this.hide();
          this.EventBus.$emit("member_update");
          this.EventBus.$emit("GLOBAL_NOTIFY", { title: "Member Plan Paused", message: "Plan was paused successfully" });
        })
        .catch((err) => {
          this.isLoading = false;
          this.errorTitle = "Error pausing the plan";
          this.errorMessage = "Sorry, we had trouble pausing this plan. The technicians have been notified. Please try again.";
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
